module.exports = __webpack_public_path__ + "static/nest-3d3303907f0f9bc72db3da0a581a3683.svg";